export const fipCodes = [
  'Alameda County',
  'Alpine County',
  'Amador County',
  'Butte County',
  'Calaveras County',
  'Colusa County',
  'Contra Costa County',
  'Del Norte County',
  'El Dorado County',
  'Fresno County',
  'Glenn County',
  'Humboldt County',
  'Imperial County',
  'Inyo County',
  'Kern County',
  'Kings County',
  'Lake County',
  'Lassen County',
  'Los Angeles County',
  'Madera County',
  'Marin County',
  'Mariposa County',
  'Mendocino County',
  'Merced County',
  'Modoc County',
  'Mono County',
  'Monterey County',
  'Napa County',
  'Nevada County',
  'Orange County',
  'Placer County',
  'Plumas County',
  'Riverside County',
  'Sacramento County',
  'San Benito County',
  'San Bernardino County',
  'San Diego County',
  'San Francisco County',
  'San Joaquin County',
  'San Luis Obispo County',
  'San Mateo County',
  'Santa Barbara County',
  'Santa Clara County',
  'Santa Cruz County',
  'Shasta County',
  'Sierra County',
  'Siskiyou County',
  'Solano County',
  'Sonoma County',
  'Stanislaus County',
  'Sutter County',
  'Tehama County',
  'Trinity County',
  'Tulare County',
  'Tuolumne County',
  'Ventura County',
  'Yolo County',
  'Yuba County',
];
